<template>
	<loading-indicator v-if="loading" class="my-5" />
	<validation-observer v-else v-bind="$attrs" ref="observer" v-slot="{ invalid }">
		
		<b-form @submit.prevent="save" >
			<b-card no-body :class="flush ? 'border-0' : ''">
				<slot name="header"></slot>
				<!-- {{caseRequestAppeal}} -->
				<b-card-body>
					<b-row>
						<b-col cols="6">
							<validation-provider
								vid="status"
								name="Status"
								:rules="{ required: true }"
								v-slot="validationContext"
								>
								<b-form-group label="Level" label-for="status" label-cols-lg="4">
									<b-form-input
										v-model="caseRequestAppeal.insurance_provider_appeal_level.label"
										:state="getValidationState(validationContext)"
										name="status"
										class="ml-1"
										required
										readonly
									/>
									<b-form-invalid-feedback
										v-for="error in validationContext.errors"
										:key="error"
										v-text="error"
									/>
								</b-form-group>

							</validation-provider>
						</b-col>
						<b-col cols="6">
							<b-form-group label="Type" label-for="request_type" label-cols-lg="3" class="mb-4">
							<b-form-select
								v-model="entity.request_type"
								@change="handleTypeChange"
								:options="requestTypes"
								:disabled="loadingRequestTypes || saving || entity.id!= null"
								required
								value-field="value"
								text-field="name"
							/>
							</b-form-group>
						</b-col>
					</b-row>

					<b-row>
						<b-col>
							<validation-provider
								vid="name"
								name="Details"
								:rules="{ required: false, min: 2, max: 50 }"
								v-slot="validationContext"
							>
								<b-form-group
									label="Details"
									label-for="name"
									label-cols-lg="2"
									description="Request Details"
								>
									<b-form-input
										autofocus
										name="name"
										type="text"
										v-model="entity.name"
										:state="getValidationState(validationContext)"
										:disabled="saving"
									/>
									<b-form-invalid-feedback
										v-for="error in validationContext.errors"
										:key="error"
										v-text="error"
									/>
								</b-form-group>
							</validation-provider>
						</b-col>
					</b-row>

					<!-- Assigned To is hidden but we are using this value internally so that it can be used later -->
					<!-- <validation-provider
						vid="assigned_to"
						name="Assigned To"
						:rules="{ required: false }"
						v-slot="validationContext"
					>
						<b-form-group label="Assigned To" label-for="assigned_to" label-cols-lg="4">
							<b-form-select
								v-model="entity.assigned_to"
								name="assigned_to"
								:options="users"
								:disabled="saving"
								value-field="id"
								text-field="full_name"
							>
								<template #first>
									<option :value="null">(Unassigned)</option>
								</template>
							</b-form-select>
							<b-form-invalid-feedback
								v-for="error in validationContext.errors"
								:key="error"
								v-text="error"
							/>
						</b-form-group>
					</validation-provider> -->

					<!-- field to displya when type selected as Medical Record -->
					<b-row v-if="isMedicalRecord || entity.request_type==='MedicalRecord'">
						<b-col cols="6" v-if="isMedicalRecord || entity.request_type==='MedicalRecord'">
							<validation-provider
								vid="followUp_date"
								name="Follow Up Date"
								:rules="{ required: true, numeric: true }"
								v-slot="validationContext"
							>
								<b-form-group label="Follow Up Date" label-for="followUp_date" label-cols-lg="4">
									<b-form-input
										type="date"
										v-model="entity.followUp_date"
										name="followUp_date"
										required="false"
										:readonly="false"
										:disabled="saving"
										:min="minDate"
									/>
									<!-- <b-form-invalid-feedback
										v-for="error in validationContext.errors"
										:key="error"
										v-text="error"
									/> -->
								</b-form-group>
							</validation-provider>
						</b-col>
						<!-- choose option to request medical Record -->
						<b-col cols="6">
							<b-form-group label="Submit To" label-cols-lg="3">
								<b-form-select label=" Submit To " v-model="entity.submittedTo"
									@change="OnSubmitMethodChange">
									<option value="Facility">Facility</option>
									<!-- <option value="agency">Agency</option> -->
									<option value="User">User</option>
								</b-form-select>
							</b-form-group>
						</b-col>

						<b-col cols="6" style="display: none;">
							<b-form-group style="display: none;"
								label="Priority"
								label-for="priority"
								label-cols-lg="4"
								description="This is a high priority request."
							>
								<b-form-checkbox name="priority" v-model="entity.priority">Priority</b-form-checkbox>
							</b-form-group>
						</b-col>
						<b-col cols="6" v-if="!entity.id">
							<b-form-group
								label="Urgent"
								label-for="Urgent"
								label-cols-lg="4"
								description="This is an urgent request."
							>
								<b-form-checkbox name="urgent" v-model="entity.urgent"></b-form-checkbox>
							</b-form-group>
						</b-col>
						<b-col cols="6" v-if="entity.id">
							
						</b-col>
						<!-- show user list if submit to is selected as user -->
						<b-col cols="6">
							<div v-if="entity.submittedTo === 'User'">
								<b-form-group label="Search User" label-cols-lg="3">
									<div class="position-relative">
										<b-form-input v-model="searchUser" @input="handleUserSearch"
											placeholder="Search user..."></b-form-input>
									</div>

									<b-list-group v-if="entity.submittedTo === 'User' && searchResults.length > 0">
										<b-list-group-item v-for="(user, index) in searchResults" :key="index"
											@click="selectUser(user)">
											{{ user.text }}
										</b-list-group-item>
									</b-list-group>
								</b-form-group>
							</div>
							<div v-if="entity.submittedTo === 'Facility'">
								<b-form-group label="Search Facility" label-for="facilitySearch" label-cols-lg="3">
									<div style="display: flex; flex: 1;">
										<b-form-input 
											type="text" 
											v-model="facilitySearchText"
											placeholder="Type to search facility..." 
											style="flex: 1; align-self: center;"
											@input="searchFacilities"
										/>
									</div>
								</b-form-group>
								<div v-if="entity.submittedTo === 'Facility' && searchResults.length > 0">
									<b-list-group>
										<b-list-group-item v-for="facility in searchResults" :key="facility.id"
											@click="selectFacilityAndFetchDetails(facility)">
											{{ facility.name }} <b-badge pill 
														v-if="facility.is_duplicate"
														variant="warning" 
														title="Duplicate"
														>
															Duplicate  
														</b-badge>
														<b-badge pill 
														v-if="facility.has_contract"
														variant="info"
														title="Duplicate"
														>
														Contract  
														</b-badge>
										</b-list-group-item>
									</b-list-group>
								</div>
							</div>
						</b-col>
						<!-- <b-col cols="6">
							<b-form-group
								label="Priority"
								label-for="priority"
								label-cols-lg="3"
								description="This is a high priority request."
							>
								<b-form-checkbox name="priority" v-model="entity.priority">Priority</b-form-checkbox>
							</b-form-group>
						</b-col> -->
						
					</b-row>
					<b-row v-if="isMedicalRecord || entity.request_type==='MedicalRecord'">
						
						<b-form-textarea
						v-if="!entity.id"
						name="note"
					v-model="entity.note"
					:autofocus="autofocus"
					:disabled="disabled || saving"
					:rows="rows"
					:max-rows="maxRows"
					:class="inputClass"
					:placeholder="placeholder"
					style="resize: vertical; overflow-y: auto"
					:style="{ minHeight, maxHeight }"
				/>
					</b-row>
					<!-- Ends here -->

					<!-- day to respond field -->
					<b-row v-if="entity.request_type!='MedicalRecord'">
						<b-col cols="6">
							<validation-provider
								vid="letter_date"
								name="Letter Date"
								:rules="{ required: true, numeric: true }"
								v-slot="validationContext"
							>
								<b-form-group label="Letter Date" label-for="letter_date" label-cols-lg="4">
									<b-form-input
										type="date"
										v-model="entity.letter_date"
										name="letter_date"
										required="false"
										:readonly="false"
										:disabled="saving"
									/>
									<!-- <b-form-invalid-feedback
										v-for="error in validationContext.errors"
										:key="error"
										v-text="error"
									/> -->
								</b-form-group>
							</validation-provider>
						</b-col>
						<b-col cols="6">
							<validation-provider
								vid="day_to_respond"
								name="Days To Respond"
								:rules="{ required: true, numeric: true }"
								v-slot="validationContext"
							>
								<b-form-group label="Days To Respond" label-for="day_to_respond" label-cols-lg="3">
									<b-form-input
										type="number"
										v-model="entity.day_to_respond"
										name="day_to_respond"
										required="required"
										:readonly="false"
										:disabled="saving"
										:state="getValidationState(validationContext)"
										@input="validateDaysToRespond"
									/>
									<p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p>
									<!-- <b-form-invalid-feedback
										v-for="error in validationContext.errors"
										:key="error"
										v-text="error"
									/> -->
								</b-form-group>
							</validation-provider>
						</b-col>
					</b-row>

					<!-- Due Date -->
					<b-row v-if="entity.request_type!='MedicalRecord'">
						<b-col  cols="6">
							<validation-provider
								vid="due_date"
								name="Due Date"
								:rules="{ required: true }"
								v-slot="validationContext"
							>
								<b-form-group label="Due Date" label-for="due_date" label-cols-lg="4">
									<b-form-input
										type="date"
										v-model="due_date"
										name="due_date"
										required="required"
										:readonly="true"
										:disabled="saving"
										:state="getValidationState(validationContext)"
									/>
									<b-form-invalid-feedback
										v-for="error in validationContext.errors"
										:key="error"
										v-text="error"
									/>
								</b-form-group>
							</validation-provider>
						</b-col>
						<b-col  cols="4">
							<validation-provider
								vid="day_to_decision"
								name="Days to Decision"
								:rules="{ required: true, numeric: true }"
								v-slot="validationContext"
							>
								<b-form-group label="Days to Decision" label-for="day_to_design" label-cols-lg="4">
									<b-form-input
										type="number"
										v-model="entity.day_to_decision"
										name="day_to_decision"
										required="required"
										:readonly="false"
										:disabled="saving"
										:state="getValidationState(validationContext)"
										style="margin-left: 11px;"
										@input="validateDaysToDecision"
										
									/>
									<p v-if="errorMessage2"  class="text-danger">{{ errorMessage2 }}</p>
									<!-- <b-form-invalid-feedback
										v-for="error in validationContext.errors"
										:key="error"
										v-text="error"
									/> -->
								</b-form-group>
							</validation-provider>
						</b-col>
						<b-col  cols="2">
							<validation-provider
								vid="estimated"
								name="Estimated"
								:rules="{ required: true }"
								v-slot="validationContext"
							>
								<b-form-checkbox
									v-model="entity.estimated"
									name="estimated"
									:readonly="false"
									:disabled="saving"
									:state="getValidationState(validationContext)"
								>
									Estimated
								</b-form-checkbox>
								<b-form-invalid-feedback
									v-for="error in validationContext.errors"
									:key="error"
									v-text="error"
								/>
							</validation-provider>
						</b-col>
					</b-row>



					<b-form-group
						v-if="entity.request_type!='MedicalRecord'"
						label="Priority"
						label-for="priority"
						label-cols-lg="2"
						description="This is a high priority request."
					>
						<b-form-checkbox name="priority" v-model="entity.priority">Priority</b-form-checkbox>
					</b-form-group>

					<!-- <validation-provider
						vid="agency_id"
						name="Agency"
						:rules="{ required: false }"
						v-slot="validationContext"
					>
						<b-form-group label="Agency" label-for="agency" label-cols-lg="4">
							<b-input-group>
								<b-select
									name="agency_id"
									v-model="agency_autofill"
									:options="agencies"
									:disabled="saving || loadingAgencies"
									:state="getValidationState(validationContext)"
									value-field="id"
									text-field="name"
								>
									<template #first>
										<b-select-option :value="null"> (None) </b-select-option>
									</template>
								</b-select>
								<template #append>
									<b-button
										variant="primary"
										@click="addingAgency = !addingAgency"
										:active="addingAgency"
									>
										<font-awesome-icon icon="plus" fixed-width />
									</b-button>
								</template>
							</b-input-group>
							<b-form-invalid-feedback
								v-for="error in validationContext.errors"
								:key="error"
								v-text="error"
							/>
						</b-form-group>
					</validation-provider> -->

					<!-- <div v-if="addingAgency" class="mb-4">
						<agency-form @cancel="addingAgency = false" @saved="addedNewAgency">
							<template #header>
								<b-card-header>
									<div class="d-flex justify-content-between align-items-center">
										<span class="font-weight-bold">Add New Agency</span>
										<b-button
											variant="secondary"
											size="sm"
											@click="addingAgency = false"
											title="Cancel"
											class="mb-0"
										>
											<font-awesome-icon icon="remove" fixed-width class="my-0 py-0" />
										</b-button>
									</div>
								</b-card-header>
							</template>
						</agency-form>
					</div> -->

					<!-- <validation-provider
						vid="insurance_provider_id"
						name="Insurance Provider"
						:rules="{ required: false }"
						v-slot="validationContext"
					>
						<b-form-group label="Insurance Provider " label-for="insurance_provider" label-cols-lg="4">
							<b-input-group>
								<b-select
									name="insurance_provider_id"
									v-model="insurance"
									:options="insuranceProviders"
									:disabled="saving || loadingInsuranceProviders"
									:state="getValidationState(validationContext)"
									value-field="id"
									text-field="name"
								>
									<template #first>
										<b-select-option :value="null"> (None) </b-select-option>
									</template>
								</b-select>
								<template #append>
									<b-button
										variant="primary"
										@click="addingInsuranceProvider = !addingInsuranceProvider"
										:active="addingInsuranceProvider"
									>
										<font-awesome-icon icon="plus" fixed-width />
									</b-button>
								</template>
							</b-input-group>
							<b-form-invalid-feedback
								v-for="error in validationContext.errors"
								:key="error"
								v-text="error"
							/>
						</b-form-group>
					</validation-provider> -->

					<!-- <div v-if="addingInsuranceProvider" class="mb-4">
						<insurance-provider-form
							@cancel="addingInsuranceProvider = false"
							@saved="addedNewInsuranceProvider"
						>
							<template #header>
								<b-card-header>
									<div class="d-flex justify-content-between align-items-center">
										<span class="font-weight-bold">Add Insurance Provider</span>
										<b-button
											variant="secondary"
											size="sm"
											@click="addingInsuranceProvider = false"
											title="Cancel"
											class="mb-0"
										>
											<font-awesome-icon icon="remove" fixed-width class="my-0 py-0" />
										</b-button>
									</div>
								</b-card-header>
							</template>
						</insurance-provider-form> 
					</div>-->
				</b-card-body>

				<b-card-footer>
					<b-row>
						<b-col cols="12" md="6" xl="4" class="mb-4 mb-md-0">
							<b-button v-if="!disableCancel" block variant="light" @click="cancel" class="btn btn-outline-danger">Cancel</b-button>
						</b-col>
						<b-col cols="12" md="6" offset-xl="4" xl="4">
							<b-button
								block
								variant="light"
								type="submit"
								:disabled="saving || disabled"
								:title="invalid ? 'Please fix any validation errors' : 'Save'"
								@click="buttonPressed"
								class="btn btn-outline-primary"
							>
								<font-awesome-icon icon="circle-notch" v-if="saving" spin fixed-width />
								<span v-if="entity.request_type!='MedicalRecord'">Save</span>
								<span v-else>Save and Submit</span>
							</b-button>
						</b-col>
					</b-row>
				</b-card-footer>
			</b-card>
		</b-form>
	</validation-observer>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import { formatErrors, getValidationState } from "@/validation";
import { getDateOffsetDaysString } from "@/shared/helpers/dateHelper";
import AgencyForm from "@/clients/components/Agencies/Form.vue";
import InsuranceProviderForm from "@/clients/components/InsuranceProviders/Form.vue";
import moment from 'moment';
import axios from "axios";

export default {
	name: "CaseRequestForm",
	components: {
		AgencyForm,
		InsuranceProviderForm,
	},
	props: {
		id: {
			default: null,
		},
		caseEntity: {
			type: Object,
			default: () => {
				return {
					id: null,
				};
			},
		},
		flush: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		disableCancel: {
			type: Boolean,
			default: false,
		},
		appealLevel: {
            type: String, // Assuming appeal level is of type string
            default: ''
        },
		caseRequestAppeal: {
			type: Object,
		}
	},
	watch: {
        // appealLevel(newVal) {
        //     // Find the option that matches the appealLevel value
           
        // }
		'entity.day_to_respond'(newVal) {
			
			if (newVal && this.entity.letter_date) {
				this.updateDueDate();
			}
			if(newVal == 0){
				this.updateDueDate();
			}
		},
		'entity.letter_date'(newVal) {
			if (this.entity.day_to_respond) {
				this.updateDueDate();
			}
		}
		
    },
	created(){
		// console.log('Current appeal level in case request form:', this.appealLevel);
		// this.status = this.appealLevel;
	},
	data() {
		return {
			loading: true,
			saving: false,
			placeholder: 'Add a note...',
			entity: {
				id: this.id,
				case_id: this.caseEntity.id,
				name: "",
				// request_type: this.defaultRequestType,
				request_type: null,
				assigned_to: this.caseRequestAppeal.assigned_to,
				//assigned_to: this.$authUser.id,
				priority: false,
				// due_date: getDateOffsetDaysString(2),
				due_date: '',
				day_to_respond: null,
				day_to_decision: null,
				// letter_date: this.caseRequestAppeal.letter_date,
				letter_date: null,
				estimated: false,
				status: '',
				appeal_level:null,
				request_status:'InProcess',
				followUp_date: null,
				submittedTo: null,
				submittedTo_ID: null,
				user_id : null,
				submittedTo_name: null,
				insurance_provider_id : this.caseEntity.insurance_provider_id,
				agency_id: this.caseRequestAppeal.agency_id,
				facility_id : this.caseEntity.facility_id,
				note: null,
			},
			loadingRequestTypes: false,
			addingAgency: false,
			addingInsuranceProvider: false,
			sendToUserName: '',
			// Discussion point: 1
			// TODO: create a seperate json file for below data
			statusOptions: [
				{ value: 1, label: "ADR" },
				{ value: 2, label: "Discussion" },
				{ value: 3, label: "Redetermination" },
				{ value: 4, label: "Reconsideration" },
				{ value: 5, label: "ALJ Hearing" },
				{ value: 6, label: "Level 4" },
				{ value: 7, label: "Level 5" },

			],
			letterData: null,	
			due_date:null,
			insurance:null,
			agency_autofill:null,
			insuranceData:[],
			errorMessage:'',
			errorMessage2:'',
			isMedicalRecord:false,
			// submittedTo: null,
			searchUser: '',
			searchResults: [],
			userList: [], // Array to store the full_name of users
			selectedUser: null, // Selected user from the list
			facilitySearchText: '',
			request_id:null,
			isValidated:true,
		};
	},
	computed: {
  	...mapGetters({
    currentUserId: "userId",
    users: "users/active",
    loadingUsers: "users/loadingActive",
    defaultRequestType: "caseRequests/defaultType",
    requestTypes: "caseRequests/types",
    agencies: "agencies/active",
    loadingAgencies: "agencies/loadingActive",
    insuranceProviders: "insuranceProviders/active",
    loadingInsuranceProviders: "insuranceProviders/loadingActive",
  }),

  // Compute the minimum date (today's date)
  minDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  },
},
	
	mounted() {
		
				
		if(this.id=== null ) {

			this.searchResults = [];
			let facilitySearchData = {
			id : this.caseEntity.facility.id,
			name : this.caseEntity.facility.display_name,
				
				
			};
			this.selectFacilityAndFetchDetails(facilitySearchData);
			this.searchResults = [];
		} 
		this.test();
		this.fetchuserlist();
		if (this.id) {
			this.refresh();
			
			//this.getSentoName(this.entity);
			
		} else {
			this.loading = false;
				
		}
		
		// for calling autofillform function during mounting phase for autofilling the form
		if(true){
			this.autoFillForm();
		}
		
	},
	methods: {
		getSentoName(getFaName){
			
			axios.post('/client/getMRSentToUserName', {
				id: getFaName.submittedTo_ID,
				submittedTo:getFaName.submittedTo
			
			})
			.then(response => {
				this.sendToUserName = response.data.userName;
				
				
			})
			.catch(error => {
				// Handle error
				console.error(error);
			});
		},
	getValidationState,
		cancel(e) {
			if (e) {
				e.preventDefault();
			}

			this.$emit("cancel");
		},
		async refresh() {
			try {
				this.loading = true;

				const response = await this.$store.dispatch("caseRequests/get", {
					id: this.id,
				});

				this.entity = response;
				axios.post('/client/getMRSentToUserName', {
				id: this.entity.submittedTo_ID,
				submittedTo:this.entity.submittedTo
			
			})
			.then(response => {
				if(this.entity.submittedTo === 'User') {
				 this.sendToUserName = response.data.userName;
				}
			this.searchResults = [];
			let facilitySearchData = {
			id : this.entity.submittedTo_ID,
			name : response.data.userName,
		
			};
			let userSearchData={
				id : this.entity.submittedTo_ID,
				text : response.data.userName,
			};
			this.selectFacilityAndFetchDetails(facilitySearchData);
			this.selectUser(userSearchData);
			this.searchResults = [];
				
			})
			.catch(error => {
				// Handle error
				console.error(error);
			});
				this.$emit("loaded", response);
			} catch (e) {
				this.$store.dispatch("apiError", {
					error: e,
					message: "Failed to find request",
				});
			} finally {
				this.loading = false;
			}
		},
		async save() {
			try {
				
				
				this.saving = true;
				this.entity.appeal_level = this.caseRequestAppeal.id;
				if(this.entity.day_to_respond < 0 || this.entity.day_to_decision < 0){
					this.$store.dispatch("notify", {
						variant: "danger",
						title: "Request Form input validation",
						message: "Days To Decision and Days To Respond can only accept 0 or above values.",
					});
				}else{
					this.entity.due_date = this.due_date;
					// validations on medical records
					if(this.isMedicalRecord == true && this.entity.submittedTo == null){
						this.isValidated = false;
						this.$store.dispatch("notify", {
							variant: "danger",
							title: "Request Form input validation",
							message: "Submit To is required.",
						});
					}
					// this.selectedUser = user.value; // Set the selected user ID or value
					// this.searchUser = user.text; // Set the search bar value
					// this.searchResults = []; // Clear the search results
					// this.entity.submittedTo_ID = user.value;
					// this.entity.submittedTo_name = user.text;
					if(this.entity.request_type === 'MedicalRecord') {
						this.entity.due_date = this.entity.followUp_date;
					}
					if(this.isMedicalRecord == true && (this.entity.submittedTo_ID == null || this.entity.submittedTo_name == null)){
						this.isValidated = false;
						this.$store.dispatch("notify", {
							variant: "danger",
							title: "Request Form input validation",
							message: "User/Facility is required.",
						});
					}
					if(this.isMedicalRecord == true){
						this.entity.day_to_respond = 0;
						this.entity.day_to_decision = 0;
						this.entity.due_date = this.entity.followUp_date;
						this.entity.request_status = 'Submitted';
						this.entity.priority='1';
						this.entity.urgent=this.entity.urgent ? 1 : 0;
						//this.entity.assigned_to = this.$authUser.id;
						
					}
					if(this.isValidated == true){
						const response = await this.$store.dispatch("caseRequests/save", this.entity);
						
						this.request_id = response.id;

						this.$emit("saved", response);
						this.$emit("update:id", response.id);

						// update outgoing table at the time of request creation if request type
						// is 'Medical Records'
						// assigned_to_user
						// get assigned to user object details
						var assigned_to_user = this.caseRequestAppeal.assigned_to_user;	
						if (!this.entity.id) {
							this.$store.dispatch("notify", {
								variant: "success",
								title: "Request created",
								message: "Request has been added successfully.",
							});
						}
					}
					
				}
				
			} catch (e) {
				if (e.response.data.errors) {
					this.$refs.observer.setErrors(formatErrors(e.response.data.errors));
				}

				this.$store.dispatch("apiError", {
					error: e,
					message: "Failed to save request. Please check for errors.",
					variant: "warning",
				});
			} finally {
				// update medical records realted data in outgoing documents
				try{
					if(this.isMedicalRecord == true){
					
					const response1 = await this.$store.dispatch("appealPackets/submitMedicalRecord", {
						case_id: this.entity.case_id,
						appeal_id: this.caseRequestAppeal.id,
						filename: null,
						delivery_method:this.entity.submittedTo,
						status_message:null,
						// client_id
						agency_id:null,
						packageSentViaSnailMail:null,
						mailNotes:null,
						ftpPortalUrl:null,
						ftpUsername:null,
						ftpPassword:null,
						EsmdPortalUrl:null,
						EsmdUsername:null,
						EsmdPassword:null,
						email:null,
						website:null,
						contactNumber:null,
						fax:null,
						carrier:null,
						tracking:null,
						// sent_date_time:null,
						request_id: this.request_id,
						name_of_submit_to: this.entity.submittedTo,              // either user/facility in case of medical records
						submit_to: this.entity.submittedTo_name,
						facility_name:this.caseEntity.facility.name,
						displayfilename:null,
						appeal_level_name: this.caseRequestAppeal.insurance_provider_appeal_level.label,
						request_level_name: this.entity.name,
						assign_to:assigned_to_user.first_name+' '+assigned_to_user.middle_name+' '+assigned_to_user.last_name,
						request_type:this.entity.request_type

						// set complete outgoing data ends here
					});

					
					if(this.entity.note!= null) {
						this.addNote(this.entity.note);
					}
				}
				}catch{
					
				}
				

				this.saving = false;
				this.$emit("saved", response);
				this.$emit("update:id", response.id);
			}
		},
		async addNote(note) {
			
			try {
				const response = await this.$store.dispatch("appealNotes/addNote", {
					id: this.caseRequestAppeal.id,
					notes: note,
					request_id:this.request_id,
				});
				
                

			} catch (e) {
				
			} finally {
				
			}
		},
		addedNewAgency(agency) {
			this.$store.dispatch("agencies/getActive");
			this.addingAgency = false;
			this.entity.agency_id = agency.id;
		},
		addedNewInsuranceProvider(insuranceProvider) {
			this.$store.dispatch("insuranceProviders/getActive");
			this.addingInsuranceProvider = false;
			this.entity.insurance_provider_id = insuranceProvider.id;
		},

		formatDate(dateString) {
			const date = new Date(dateString);
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		},

		addDaysToDate(dateString, days)
		 {
			const date = new Date(dateString);
			date.setDate(date.getDate() + days);
			return date.toISOString().split('T')[0];
		},

		async autoFillForm() {
			try{
				// const url = "http://localhost:8765/client/textract";

				// const responses = await axios.get(url, {
				// headers: {
				// 	"Accept": "application/json",
				// 	// You can add other headers here if needed
				// },
				// });
				// this.letterData = responses.data[0]; 
				// this.daysToRespond =  parseInt(responses.data[0].days_to_respond, 10);
				// this.due_date = this.formatDate(responses.data[0].letter_date);  
				// this.due_date = this.addDaysToDate(this.due_date , this.daysToRespond);
				// populate due_date only if we are creating first request
			
				if(await this.requestExists(this.caseRequestAppeal.id,this.caseRequestAppeal.client_id,this.caseRequestAppeal.case_id) === false){
				
					this.entity.letter_date = this.caseRequestAppeal.letter_date;
				}
				// this.insurance = responses.data[0].insurance_provider;
				// // this.insurance = responses.data[0].insurance_provider; 
				// this.insuranceProviders.unshift(this.insurance);
				// this.agency_autofill = responses.data[0].sender;
				// this.agencies.unshift(this.agency_autofill);
			} 
			catch (error) {
				console.error("Error:", error);
			}
    	},

		async buttonPressed() {
		const data = {'id':this.entity.assigned_to}

				// Use Axios to make the request to the controller for sending user_id 
				
				const resp = await axios.post('/client/sendemail', data);
				
				// Reload the page
				// location.reload();

		},

		async test(){
			try {
				const url = "/client/insuranceappeal";
				
				const response = await axios.get(url, {
				headers: {
					"Accept": "application/json",
					// You can add other headers here if needed
				},
				});
				// Handle the response data here
				// this.insuranceData = response.data;
				let count =1 ;
				response.data.forEach((item, index) => {
				// console.log(`Element at index ${index}:`, item.insurance_provider_id);
				if(item.insurance_provider_id==this.caseEntity.insurance_provider_id){
					this.insuranceData.push({label:item.label, id:item.id , count:count});
					count ++;
				}
				});
				this.insuranceData.sort((a,b)=> a.id - b.id);
				this.insuranceData.forEach((item,index)=>{
					item.count=index;
				});
				// console.log("response = " , this.insuranceData);
				// console.log("case entity =", this.caseEntity);

				// console.log('setting status value:-');
				const matchedAppealLevel = response.data.find(item => item.label === this.appealLevel);
				if (matchedAppealLevel) {
					this.entity.status = matchedAppealLevel.id;
					// update appeal level count below
					const selectedOption = this.insuranceData.find(option => option.id === this.entity.status);
					if (selectedOption) {
						this.entity.appeal_level = selectedOption.count;
					} else {
						this.entity.appeal_level = null; // Handle the case where no option is selected
					}
				}
				// auto populate request type [default: Hearing]
				// this.entity.request_type = this.defaultRequestType;
				// this.entity.letter_date = this.caseRequestAppeal.letter_date;

				// console.log(JSON.stringify(this.entity.status));
				// console.log('default requestType is :-');
				// console.log(JSON.stringify(this.entity.request_type));
			    // console.log('caseRequestAppeal:-');
				// console.log(JSON.stringify(this.caseRequestAppeal));
				// [{"name":"Documentation","value":"DOCUMENTATION"},{"name":"Hearing","value":"HEARING"}]
				} 
			catch (error) {
				console.error(error);
			}

		},

		updateAppealLevelCount(){
			
			const selectedOption = this.insuranceData.find(option => option.id === this.entity.status);
			if (selectedOption) {
				this.entity.appeal_level = selectedOption.count;
			} else {
				this.entity.appeal_level = null; // Handle the case where no option is selected
			}
			
		},

		// validate days to respond input to accept only positive integer
		validateDaysToRespond() {
			// Remove any non-digit characters

			if(this.entity.day_to_respond < 0){
				this.errorMessage = 'Please enter a value greater than or equal to 0.';
			}else {
				this.errorMessage = '';
			}
		},
		validateDaysToDecision(){
			if(this.entity.day_to_decision < 0){
				this.errorMessage2 = 'Please enter a value greater than or equal to 0.';
			}else {
				this.errorMessage2 = '';
			}
		},
		updateDueDate() {
			if(this.entity.letter_date!= null) {
			this.due_date = moment(this.entity.letter_date)
				.add(this.entity.day_to_respond, 'days')
				.format('YYYY-MM-DD');
			
			}
		},
		async requestExists(appeal_level, client_id, case_id) {

			try {
				// this.loading = true;

				const response = await this.$store.dispatch("caseRequests/existingRequest", {
					id: appeal_level,
					client_id: client_id,
					case_id: case_id
				});

				return response.statusMessage
				// this.entity = response;
				// this.$emit("loaded", response);
			} catch (e) {
				this.$store.dispatch("apiError", {
					error: e,
					message: "Failed to find request",
				});
			} finally {
				this.loading = false;
			}
		},
		handleTypeChange(){
			if (this.entity.request_type === 'MedicalRecord') {
			
				this.isMedicalRecord = true;
				//this.entity.request_type="MedicalRecord";
			} else {
				this.isMedicalRecord = false;
				//this.entity.request_type="Hearing";
			}
		},
		handleUserSearch() {
			// Implement search logic here and update searchResults
			this.searchResults = this.userList.filter(user => user.text.toLowerCase().includes(this.searchUser.toLowerCase()));
		},
		async fetchuserlist() {
			try {
				const url = "/client/userslist";

				// Fetch data from the server
				const response = await axios.get(url, {
					headers: {
						"Accept": "application/json",
					},
				});

				this.userList = response.data.map(user => ({
					value: user.id,
					text: user.full_name,
				}));

				

			} catch (error) {
				console.error("Error fetching client facilities:", error);
			}
		},
		selectUser(user) {
			this.selectedUser = user.value; // Set the selected user ID or value
			this.searchUser = user.text; // Set the search bar value
			this.searchResults = []; // Clear the search results
			this.entity.submittedTo_ID = user.value;
			this.entity.user_id = user.value;
			this.entity.submittedTo_name = user.text;
		
		},
		OnSubmitMethodChange() {
			
			// Handle any logic when the "Submit To" dropdown changes
			// For example, you might want to reset some fields based on the selected option
			if (this.entity.submittedTo === 'User') {
				this.selectedDeliveryMethod = 'Email'; // Reset the selected delivery method
				let userSearchData={
				id : this.entity.submittedTo_ID,
				text : this.sendToUserName,
			};
			//this.selectFacilityAndFetchDetails(facilitySearchData);
			this.selectUser(userSearchData);
			} else if(this.entity.submittedTo === 'Facility') {
				let facilitySearchData = {
					id : this.caseEntity.facility.id,
					name : this.caseEntity.facility.display_name,
			
			};
			this.selectFacilityAndFetchDetails(facilitySearchData);
			}
		},
		async searchFacilities() {
			try {
				if(this.facilitySearchText.length > 0){
					// this.facilitySelected = false;
					const response = await axios.get('/client/searchfacility', {
						params: {
							search: this.facilitySearchText
						}
					});
					this.searchResults = response.data;
					
					this.selectedDeliveryMethod = '';
					//this.faxDetails = [];
					//this.emailDetails = [];
				}else{
					this.searchResults = [];
					// this.facilitySelected = true;
				}
				
			} catch (error) {
				console.error('Error searching facilities:', error);
			}
		},
		async selectFacilityAndFetchDetails(facility) {
			try {
			
				this.facilitySearchText = '';
				this.searchResults = [];
				this.facilitySearchText = facility.name;
				this.entity.submittedTo_ID = facility.id;
				this.entity.submittedTo_name = facility.name;
				
				this.facilityName = facility.name;

				// Call FacilityReceivingList method with the selected facility's ID
				const { emailDetails, faxDetails } = await this.FacilityReceivingList(facility.id);

				// Update component data with received email and fax details
				this.emailDetails = emailDetails;
				this.faxDetails = faxDetails;
			} catch (error) {
				console.error('Error retrieving facility receiving details:', error);
				// Handle error appropriately
			}
		},
	},
};
</script>